 <ng-template class="modal-dialog modal-dialog-scrollable" #modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modalConfig.modalTitle }}</h5>
    <div class="d-flex justify-content-end">
      <!--begin::Close-->
      <div
        class="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary"
        data-bs-toggle="tooltip"
        data-bs-dismiss="click"
        aiar-label="Hide Event"
        data-bs-original-title="Hide Event"
        data-kt-initialized="1"

      >
        <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
        <span class="svg-icon svg-icon-1" (click)="cancel.emit(false)"
          ><svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              opacity="0.5"
              x="6"
              y="17.3137"
              width="16"
              height="2"
              rx="1"
              transform="rotate(-45 6 17.3137)"
              fill="currentColor"
            ></rect>
            <rect
              x="7.41422"
              y="6"
              width="16"
              height="2"
              rx="1"
              transform="rotate(45 7.41422 6)"
              fill="currentColor"
            ></rect>
          </svg>
        </span>
        <!--end::Svg Icon-->
      </div>
      <!--end::Close-->
    </div>
  </div>
  <div class="modal-body mh-500px scroll-y">
    <ng-content></ng-content>
  </div>
  <!-- <div class="modal-footer">
      <button type="button"
              class="btn btn-outline-secondary"
              (click)="dismiss()"
              *ngIf="modalConfig.hideDismissButton === undefined || !modalConfig.hideDismissButton()"
              [disabled]="modalConfig.disableDismissButton !== undefined && modalConfig.disableDismissButton()">
        {{ modalConfig.dismissButtonLabel }}
      </button>
      <button type="submit"
              class="btn btn-primary"
              (click)="close()"
              *ngIf="modalConfig.hideCloseButton === undefined || !modalConfig.hideCloseButton()"
              [disabled]="modalConfig.disableCloseButton !== undefined && modalConfig.disableCloseButton()">
        {{ modalConfig.closeButtonLabel }}
      </button>
    </div> -->
</ng-template>
